module.exports = __webpack_public_path__ + "img/Template3.5669be50.jpg";